import { Link } from "react-router-dom";
import SEOHead from "../lib/SEOHead";
import { BOOKING_URL, NAP } from "../lib/config";
import { Phone } from "lucide-react";

export default function NotFoundPage() {
  return (
    <>
      <SEOHead
        title="Page not found"
        description="This page doesn't exist. Try the home page, rooms, or call the front desk at (660) 885-2206."
        noindex
      />
      <section className="min-h-[70vh] flex items-center bg-[#F5F0E6]">
        <div className="wb-container py-20 md:py-28">
          <div className="max-w-2xl">
            <div className="wb-eyebrow">404</div>
            <h1 className="wb-h1 mt-4">This page took a wrong turn.</h1>
            <p className="wb-body mt-5">
              Nothing at that URL. The front desk is open 24 hours if you're stuck — call{" "}
              <a href={`tel:${NAP.phoneTel}`} className="text-[#B94A15] font-bold hover:underline">{NAP.phone}</a>.
              Or try one of these:
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/" className="wb-btn-primary" data-testid="notfound-home">Home</Link>
              <Link to="/rooms" className="wb-btn-outline" data-testid="notfound-rooms">Rooms</Link>
              <Link to="/local-guide" className="wb-btn-outline" data-testid="notfound-local-guide">Local Guide</Link>
              <Link to="/faq" className="wb-btn-outline" data-testid="notfound-faq">FAQ</Link>
              <Link to="/contact" className="wb-btn-outline" data-testid="notfound-contact">Contact</Link>
              <a href={`tel:${NAP.phoneTel}`} className="wb-btn-ghost" data-testid="notfound-call">
                <Phone className="h-4 w-4" /> Call
              </a>
              <a
                href={BOOKING_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="wb-btn-secondary"
                data-testid="notfound-book"
              >
                Book Now
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
